import { Suspense, lazy } from "react";
import { Route, Routes } from "react-router";

import { pathRoutes } from "@dfp/bw-react-routing";
import { ErrorBoundary, SplashScreen } from "@dfp/react-api-core";

import { ConsentGate } from "./auth/ConsentGate.tsx";
import { UserAuthProvider } from "./auth/UserAuthProvider.tsx";
import {
  COMMIT_ID,
  DEMO_MODE,
  MEIRO_CDP_BASE_URI,
  WEBSITE_NAME,
} from "./config.ts";
import { DemoBankConnectScreen } from "./demo/DemoBankConnectScreen.tsx";

export const DashboardLazy = lazy(
  () => import("./subAppDashboard/SubAppDashboard.tsx"),
);

export const JoinLazy = lazy(() => import("./subAppJoin/JoinApp.tsx"));
export const OpsLazy = lazy(() => import("@dfp/bw-react-ops"));
export const MobileChartsLazy = lazy(
  () => import("./subAppMobileCharts/MobileChartsApp.tsx"),
);
export const MobileGatewayAppLazy = lazy(
  () => import("./subAppMobileGateway/MobileGatewayApp.tsx"),
);
export const SignupLazy = lazy(() => import("./subAppSignup/SignupApp.tsx"));
export const SessionTransferLazy = lazy(
  () => import("./subAppSessionTransfer/SessionTransferApp.tsx"),
);

export function AppRoutes() {
  return (
    <Suspense fallback={<SplashScreen />}>
      <Routes>
        {DEMO_MODE && (
          <Route path="/demo-bank-connect" element={<DemoBankConnectScreen />} />
        )}
        <Route
          path="*"
          element={
            <ErrorBoundary>
              <ConsentGate>
                <DashboardLazy />
              </ConsentGate>
            </ErrorBoundary>
          }
        />
        <Route
          path={pathRoutes.joinAppRoot}
          element={
            <ErrorBoundary>
              <ConsentGate>
                <JoinLazy />
              </ConsentGate>
            </ErrorBoundary>
          }
        />
        <Route
          path={pathRoutes.opsAppRoot}
          element={
            <ErrorBoundary>
              <UserAuthProvider>
                <OpsLazy
                  commitHash={COMMIT_ID}
                  websiteName={WEBSITE_NAME}
                  meiroCdpBaseUri={MEIRO_CDP_BASE_URI}
                />
              </UserAuthProvider>
            </ErrorBoundary>
          }
        />
        <Route
          path={pathRoutes.mobileCharts}
          element={
            <ErrorBoundary>
              <MobileChartsLazy />
            </ErrorBoundary>
          }
        />
        <Route
          path={pathRoutes.mobileAppGateway}
          element={
            <ErrorBoundary>
              <MobileGatewayAppLazy />
            </ErrorBoundary>
          }
        />
        <Route
          path={pathRoutes.sessionTransfer}
          element={
            <ErrorBoundary>
              <SessionTransferLazy />
            </ErrorBoundary>
          }
        />
        <Route
          path={pathRoutes.signup}
          element={
            <ErrorBoundary>
              <ConsentGate>
                <SignupLazy />
              </ConsentGate>
            </ErrorBoundary>
          }
        />
      </Routes>
    </Suspense>
  );
}
